import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './salesQuotationModal.css';
import { useLocation } from 'react-router-dom';

const SalesQuotationModal = ({ show, onHide, handlecheckout, handleinputclick, isLoading }) => {
  const location = useLocation();
  const addData = JSON.parse(localStorage.getItem('additionalData'))
  const { additionalData } = location.state || {};  
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className='salesQuatationModal'
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Posting For
        </Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Button className='BtnSalesQut' onClick={() => handlecheckout("Sales Quotation", true)}>
          {addData?.additionalData === 'sqUpdate' ? 'Update Sales Quotation' : 'Sales Quotation'}
        </Button>
        {!(additionalData ==="OpporItemPage" || addData?.additionalData === 'sqUpdate')&&
        <>
        <Button className='BtnSalesQut' onClick={() => handlecheckout("Sales Order", true)}>Sales Order</Button>
        <Button className='BtnSalesQut' disabled={isLoading} onClick={() => handlecheckout("CRM Post", false)}>CRM Post</Button>
        </>
          }  
          </Modal.Footer>
    </Modal>
  );
}

export default SalesQuotationModal;